export default "__VITE_ASSET__2dWR6XLK__"